import React from 'react';


class Login extends React.Component {


    render() {
        var html = '<h1>Hello, world! dddd</h1>'
        return (
            <div dangerouslySetInnerHTML={{ __html: html }} />




        )
    }

}

export default Login;